import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"

import { isTouchDevice, debounce } from '../helpers'


export default class extends Controller {
  static targets = [ "primaryImg", "secondaryImg", "data", "title"]
  initialize() {
    this.addToCart = this.element.querySelector('.button')
    this.cardType = this.element.getAttribute('data-type')
    this.isTouch = isTouchDevice()
    if(!this.isTouch){
      this.setupTl()
      window.addEventListener("resize", debounce( this.setupTl, 150 ));
    }
  }

  setupTl(){
    this.tl = gsap.timeline({
      paused:true
    })
    if(this.cardType != 'blocks'){
      this.tl.add([
        gsap.to(this.primaryImgTarget,{
          autoAlpha:0,
          duration:.25
        },'same'),
        gsap.from(this.secondaryImgTarget,{
          scale:1.25,
          duration:.25
        },'same')
      ])
    }

    this.tl.to(this.element,{
      backgroundColor: '#E8CFC2',
      duration:.25
    },"-=.25")
    .to(this.titleTarget,{
      yPercent:-100,
      duration:.25,
      autoAlpha:0
    },"-=.25")
    .fromTo(this.titleTarget,{
      yPercent:100,
      autoAlpha:0
    },{
      yPercent:0,
      duration:.25,
      autoAlpha:1,
      immediateRender:false
    },"-=.25")

    if(this.addToCart){
      this.tl.add(
        gsap.fromTo(this.addToCart,{
          autoAlpha:0,
          scale:.95,
          yPercent:-12.5,
        },{
          autoAlpha:1,
          delay:.125,
          duration:.25,
          scale:1,
          yPercent:0
        })
      ,"-=.25")
    }
  }

  play(){
    if(!this.isTouch){
      this.tl.play()
    }
  }

  reverse(){
    if(!this.isTouch){
      this.tl.reverse()
    }
  }
}